import React from "react";
import { FilterMode } from "./Filter";
import BasicGrid from "./Grid";

const NearToExpiryAllList =()=>{
    return(
        <>
        <FilterMode/>
        <BasicGrid/>
        </>
    )
};

export default NearToExpiryAllList;